export default "__VITE_ASSET__Glz3ql3A__"